import { render, staticRenderFns } from "./FileRequests.vue?vue&type=template&id=2521262e&scoped=true&"
import script from "./FileRequests.vue?vue&type=script&lang=js&"
export * from "./FileRequests.vue?vue&type=script&lang=js&"
import style0 from "./FileRequests.vue?vue&type=style&index=0&id=2521262e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521262e",
  null
  
)

export default component.exports